const styles = (theme) => ({
  root: {},
  gridItem: {
    display: 'flex',
    [theme.breakpoints.up('xs')]: {
      '&&:nth-child(odd)': {
        padding: '0 0 30px 0',
      },
      '&&:nth-child(even)': {
        padding: '0 0 30px 0',
      },
    },
    [theme.breakpoints.up('sm')]: {
      '&&:nth-child(odd)': {
        padding: '0 25px 30px 0',
      },
      '&&:nth-child(even)': {
        padding: '0 0 30px 25px',
      },
    },
    [theme.breakpoints.up('md')]: {
      '&&:nth-child(odd)': {
        padding: '0 0 30px 0',
      },
      '&&:nth-child(even)': {
        padding: '0 0 30px 0',
      },
    },
    [theme.breakpoints.up('lg')]: {
      '&&:nth-child(odd)': {
        padding: '0 25px 30px 0',
      },
      '&&:nth-child(even)': {
        padding: '0 0 30px 25px',
      },
    },
  },
});

export default styles;
